module.exports = __webpack_public_path__ + "img/case-logo-40.76e4339f.png";